import { render, staticRenderFns } from "./ImpressionColumn.vue?vue&type=template&id=59a5c982"
import script from "./ImpressionColumn.vue?vue&type=script&lang=js"
export * from "./ImpressionColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports